import React from 'react';
import {
  Box,
  BoxProps,
  HStack,
  IconButton,
  NewTextButton,
  Text,
} from '@design-system/pc';

interface NoticeBannerProps extends Omit<BoxProps<'div'>, 'ref' | 'color'> {
  /** 더보기 클릭 — 유의사항 팝업 열기 */
  onClickMore: () => void;
  /** 닫기 클릭 — 배너 숨김 */
  onClickClose: () => void;
}

/**
 * 매장찾기 리모델링/부엌/욕실 필터 선택 시 노출하는
 * 한국 소비자원 권고 안내 배너 (HSMALL-17112)
 */
const NoticeBanner = ({
  onClickMore,
  onClickClose,
  ...props
}: NoticeBannerProps) => {
  return (
    <Box
      backgroundColor="color_chip.blue.50"
      borderRadius="8px"
      padding="14px 16px 14px 20px"
      boxShadow="0px 4px 8px rgba(0, 0, 0, 0.1)"
      {...props}
    >
      <HStack space={16} alignment="center">
        <Text variant="body2" color="color_chip.primary" flex={1}>
          한샘 외 상품으로 1,500만원 이상 계약 시 전문건설업 면허 여부를 꼭 확인
          해 주세요.
        </Text>
        <NewTextButton
          size="md"
          isUnderline
          color="color_chip.blue.500"
          onClick={onClickMore}
        >
          더보기
        </NewTextButton>
        <Box
          width="1px"
          height="16px"
          backgroundColor="color_chip.gray.200"
          flexShrink={0}
        />
        <IconButton
          variant="ic_close"
          size="sm"
          aria-label="안내 닫기"
          onClick={onClickClose}
        />
      </HStack>
    </Box>
  );
};

export default NoticeBanner;
